import React from 'react';
import{Link} from 'react-router-dom';
 export default class AdminNav extends React.Component {
  //other logic
    render() {
     return(
      <nav className="navbar navbar-light navbar-expand-sm">
      <Link to="/" style={{color:"#ccc"}}>Planeta Rozwoju</Link>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
              <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="collapsibleNavbar">

              <ul className="navbar-nav">
                  <li className="nav-item">
                      <Link className="nav-link"  to="/lectorgroup/index">Grupy</Link>
                  </li>
                  <li className="nav-item">
                      <Link className="nav-link"  to="/programs/index">Kursy</Link>
                  </li>
                  
                  <li className="nav-item">
                      <Link className="nav-link"  to="/lector/setup/">Ustawienia</Link>
                  </li>
                  
                  
              </ul>
              </div>
          </nav>

     );
    }
 }